<template>
  <Card>
    <header class="subscription-promote__title">
      {{ $t('APP.IAB.SUBSCRIPTION_PROMOTE.TITLE') }}
    </header>

    <p class="subscription-promote__description">
      {{ $t('APP.IAB.SUBSCRIPTION_PROMOTE.DESCRIPTION') }}
    </p>

    <div>
      <ElButton type="primary" @click="$emit('create-button-click')">
        {{ $t('APP.IAB.SUBSCRIPTION_PROMOTE.CREATE_BTN') }}
      </ElButton>

      <a :href="documentationLink" target="_blank">
        <ElButton class="subscription-promote__more-info">
          {{ $t('APP.IAB.SUBSCRIPTION_PROMOTE.MORE_INFO') }}
          <i class="material-icons">open_in_new</i>
        </ElButton>
      </a>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/common/Card';
import lang from '@/mixins/lang';

export default {
  name: 'SuscriptionPromote',
  components: { Card },
  mixins: [lang],
  computed: {
    documentationLink() {
      const lang = this.lang === 'fa' ? 'fa' : 'en';
      return `https://developers.cafebazaar.ir/${lang}/guidelines/in-app-billing/subscription`;
    },
  },
};
</script>

<style lang="scss">
.subscription-promote {
  &__title {
    font-size: rem-calc(25px);
    font-weight: 400;
    margin-bottom: $global-margin;
  }

  &__description {
    font-size: rem-calc(14px);
    font-weight: 400;
    color: $lb-light-black;
  }

  &__more-info {
    color: $lb-color-primary;
    border-color: $lb-color-primary;
    margin-left: $global-margin;

    @include rtl() {
      margin-left: 0;
      margin-right: $global-margin;
    }
  }
}
</style>
